import React, { useState, useEffect, useMemo } from 'react';
import { Alert, Button, Modal, Form, Col } from 'react-bootstrap';
import Select from 'react-select';
import { useImmer } from 'use-immer';
import { MessageService, UserService } from '../../services';
import { ConditionalRender } from '../formControls';

const AddAudienceModal = (props) => {
    const [contacts, setContacts] = useImmer([])
    const [selectedAudience, setSelectedAudience] = useImmer([]);
    const [serviceCallError, setServiceCallError] = useImmer(null);

    useEffect(() => {
        if (props.model.message != undefined) {
            getContacts();
        }
    }, [props.message])

    const getContacts = async () => {
        setServiceCallError(null);
        var userService = new UserService();
        let params = {}

        params = { "AccountIdFilter": props.model.message.accountId, "codingEventId": props.model.message.codingEventId };

        var callResult = await userService.getContactsForUser(params);
        if (callResult.result) {
            const localAllContacts = callResult.model.accounts;
            const currAud = props.model.message.audience.map(x => x.userId);
            let mappedContacts = [];
            if (localAllContacts?.length > 0)
                mappedContacts = localAllContacts.filter(grp => grp.accountId == props.model.message.accountId || grp.accountId == 1)
                    .map(grp => {
                        let filtGrpContacts = grp.contacts.filter(x => !currAud.includes(x.id));
                        filtGrpContacts = filtGrpContacts.map(cntc => ({
                            label: cntc.fullName + ' (' + cntc.accountName + ')', value: cntc.id, accountId: grp.id, userId: cntc.id, accountName: grp.name
                        }));

                    return { label: grp.name, id: grp.id, options: filtGrpContacts }                    
                });
            setContacts(mappedContacts);
        } else {
            setServiceCallError({ title: "Error", text: "Failed to fetch contacts for audience." })
        }
    }

    const updateAudiencePrefs = async (selected, action) => {

    }

    const saveNewAudience = async () => {
        setServiceCallError(null);
        const messageService = new MessageService();
        const removeList = []
        let combinedResult = true;
        for (const aud of selectedAudience) {
            let callResult = await messageService.updateAudiencePreference(parseInt(aud.value), props.model.message.id, true);
            if (callResult.result) {
                removeList.push(aud);
            }
            combinedResult = combinedResult && callResult.result;
        }

        if (combinedResult) {
            props.updateCallback();
        } else {
            if (removeList.length > 0) {
                selectedAudience = removeList.forEach(aud => !selectedAudience.some(x => x.value != aud.value));
            }
            setServiceCallError({
                title: "Error",
                text:
                    <>
                        <p>Failed to add remaining contacts to the message audience.</p>
                        <p>You can try again or close the modal</p>
                    </>
            })
        }
    }

    return (
        <>
            <Modal.Header>Add users to message audience</Modal.Header>
            <Modal.Body>
                <ConditionalRender visible={serviceCallError}>
                    <Alert variant="danger">
                        <Alert.Heading>{serviceCallError?.title}</Alert.Heading>
                        {serviceCallError?.text}
                    </Alert>
                </ConditionalRender>
                <Form.Row>
                    <p>Please select the users you wish to add to the audience of this coding event, then press the "Add" button.</p>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <Select
                            options={contacts}
                            name="selectAudience"
                            value={selectedAudience}
                            isSearchable="true"
                            isMulti="true"
                            classNamePrefix="audience-search-select"
                            placeholder="Select..."
                            onChange={(selected, action) => {
                                setSelectedAudience(selected);
                            }}
                        />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.closeModal}>Dismiss</Button>
                <Button variant="primary" disabled={!selectedAudience?.length > 0} onClick={() => saveNewAudience()}>Save</Button>
            </Modal.Footer>
        </>
    );
};

export default AddAudienceModal